import React from 'react';

import { ModalFooter, Text } from '@chakra-ui/react';

import { Button } from 'components';

export default function Footer({ onClose }) {
  return (
    <ModalFooter
      justifyContent="flex-end">
      <Button
        size="sm"
        mr={3}
        border="1px"
        borderColor="gray.300"
        bg="white"
        _hover={{ bg: 'gray.50' }}
        _active={{}}
        onClick={onClose}>
        <Text
          variant="smallBold"
          color="primary.700">
          Cancelar
        </Text>
      </Button>
      <Button
        type="submit"
        variant="primary.blue"
        size="sm"
        onClick={onClose}>
        <Text variant="smallBold">Aplicar</Text>
      </Button>
    </ModalFooter>
  );
}
